import { ApplicationRef } from '@angular/core';

import { environment } from '@env/environment';

import { EnvConfig } from '@app/shared/types';

const currentUrl = window.location.href;

// During initial load (Visit and Wrap-Up page),
// something is triggering a navigation to `${origin}/#`, which causes Angular
// to reload and re-execute main.ts unnecessarily.
//
// To prevent redundant bootstrapping, we block the app bootstrap if this
// "empty hash" navigation is detected.
//
// The issue caused by BENERX-212 and BPHOS-13

if (currentUrl !== `${window.origin}/#` && currentUrl !== `${window.origin}/#/`) {
  fetch('./assets/config/env-config.json')
    .then((res) => res.json())
    .then((envConfig: EnvConfig) => loadBootstrapModule(envConfig))
    // Logged directly to console: APM/logging not initialized yet during bootstrap. Error will not be in Kibana
    .catch(err => console.error(`[${environment.name}] Error from main.ts`, err));
}

async function loadBootstrapModule(envConfig: EnvConfig): Promise<ApplicationRef | void> {
  try {
    const bootstrapModule = await import('./bootstrap');

    return await bootstrapModule.init(envConfig);
  } catch (err) {
    // Logged directly to console: APM/logging not initialized yet during bootstrap. Error will not be in Kibana
    return console.error(`[${environment.name}] Error from bootstrap.ts`, err);
  }
}
